import React from "react";
import svg_reply_blue from "src/img/chatBubbleActionIcons/reply_blue.svg";
import svg_cancel from "src/img/chatBubbleActionIcons/cancel_action.svg";
import { InputActionTemplate } from "./InputActionTemplate";
import { MessageContentDisplay } from "../../MessageContentDisplay";

export const ReplyContainer = ({ newMessageInReplyToEvent, onSetNewMessageThreadEvent, currentChat, textInputRef, matrixClient }) => {
    const getThreadSenderFullName = () => {
        const sender = currentChat?.users?.find(user => user.matrixUserId === newMessageInReplyToEvent?.getSender());
        return sender ? `${sender.employeeDetails.firstName} ${sender.employeeDetails.lastName}` : "";
    };

    const clearMessage = () => {
        textInputRef.current.value = "";
        onSetNewMessageThreadEvent(null);
    };
    const content = newMessageInReplyToEvent?.getContent();
    return (
        <InputActionTemplate 
            actionImageElement={<img src={svg_reply_blue} alt="Reply Preview" />}
            spanElement={<span>Replying to {getThreadSenderFullName()}</span>}
            previewMessage={<MessageContentDisplay content={content} matrixClient={matrixClient}/>}
            cancelImageElement={
                <img
                    src={svg_cancel}
                    alt="Cancel Reply"
                    onClick={clearMessage}
                    style={{ cursor: "pointer" }}
                />
            }
        />
    );
};
